module.exports = __webpack_public_path__ + "img/Go_Back.3a2ea8be.svg";